"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var FormHelperText_1 = __importDefault(require("@mui/material/FormHelperText"));
var FormControl_1 = __importDefault(require("../../Atoms/FormControl"));
var Input_1 = __importDefault(require("../../Atoms/Input"));
var InputLabel_1 = __importDefault(require("../../Atoms/InputLabel"));
var defaultProps_1 = __importDefault(require("./defaultProps"));
var TextField = function (_a) {
    var errorMessage = _a.errorMessage, id = _a.id, label = _a.label, multiline = _a.multiline, isAnswered = _a.isAnswered, shrinkLabel = _a.shrinkLabel, isAutoFilledActive = _a.isAutoFilledActive, isSafari = _a.isSafari, rows = _a.rows, experimentName = _a.experimentName, props = __rest(_a, ["errorMessage", "id", "label", "multiline", "isAnswered", "shrinkLabel", "isAutoFilledActive", "isSafari", "rows", "experimentName"]);
    return ((0, jsx_runtime_1.jsxs)(FormControl_1.default, { error: !!errorMessage, isAutoFilledActive: isAutoFilledActive, isSafari: isSafari, experimentName: experimentName, children: [label && ((0, jsx_runtime_1.jsx)(InputLabel_1.default, { shrink: shrinkLabel, isAnswered: isAnswered, htmlFor: id, experimentName: experimentName, children: label })), (0, jsx_runtime_1.jsx)(Input_1.default, __assign({ error: !!errorMessage, id: id, multiline: multiline, rows: rows, isAnswered: isAnswered, isAutoFilledActive: isAutoFilledActive }, props, { experimentName: experimentName })), errorMessage && (0, jsx_runtime_1.jsx)(FormHelperText_1.default, { children: errorMessage })] }));
};
TextField.defaultProps = defaultProps_1.default;
exports.default = TextField;
//# sourceMappingURL=TextField.js.map